import { Flex, Text } from "@chakra-ui/react";
import { fetchUnreadMessagesCnt } from "network/helper";
import { MessageCellProps } from "../types";

export function MessageCell({ projectId, unreadMessages }: MessageCellProps) {
  const unreadCount = fetchUnreadMessagesCnt(unreadMessages, projectId);

  return (
    <Flex align="center">
      {unreadCount > 0 && (
        <Text
          color="#FFF"
          bgColor="#F02828"
          borderRadius="100px"
          fontSize="14px"
          lineHeight="24px"
          fontWeight="400"
          padding="5px 20px"
          whiteSpace="nowrap"
        >
          {`${unreadCount} New Message`}
        </Text>
      )}
    </Flex>
  );
}
